module.exports = __webpack_public_path__ + "static/img/level0.7e22227b.png";